<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BAYlvs/tc-custom/9781446350058.jpg?1696085821691" alt="This image is the cover for the book Tales of the Supernatural"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tales of the Supernatural
      </h1>
      <p class="bookDescription body article font2">
        <b>A collection of supernatural stories about dreams, premonitions, and possessions.</b><br/>  <br/> Here you’ll find strange beasts, headless ghosts, and phantom faces that appear to the unsuspecting, striking fear into their very hearts. Tales include: “Premonition of the Titanic’s Doom,” “The Headless Lover,” “Screaming Skulls and Other Oddities,” and “A Stranger in the Fog.”
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Harper
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      David & Charles is an F+W Media, Inc. company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a760d166